import React, { createRef } from 'react';
import BaseClass from '../common/baseClass';
import { createPortal } from 'react-dom'; // Importa createPortal da react-dom
import $ from 'jquery'; // Importa jQuery

import { connect } from "react-redux";
import { changeDatalist, setNewUrlState } from "../../redux/actions";
import { modalItemSelector } from "../../redux/selectors";

import '../../css/page-body.css';
import TooltipCart from '../views/TooltipCart';
import FilterModels from '../FilterModels/FilterModels';
import FilterTavole from '../FilterTavole/FilterTavole';
import CartiReplacements from '../CartiReplacements/CartiReplacements';

const common = require('../common/common');
const env = require("../../config.js").default;

class ModalItem extends BaseClass {
  constructor(props) {
    super(props);
    this.state = {
      itemInfo: null,
      updData: false,
      arti: this.props.arti,
      showTooltipCarti: false,
      showReplacements: false
    };
    this.listVm = window.cc.enabledList[this.props.store.filtersState.marca];
    this.marcheVm = this.marcheVm = window.cc.enabledVMs;
    this.closeButtonRef = React.createRef();
    this.updateStateWithStoreProps();
  }
  
  componentDidMount() {
  }


  static getDerivedStateFromProps = (props, current_state) => {
    if ((props.arti !== current_state.arti)) {
      if (props.arti !== "")
        // reset Modale a ogni get_data
        return { arti: props.arti, updData: true, itemInfo: null, showTooltipCarti: false, showReplacements: false };
      else
        return { arti: props.arti };      
    }
    return null;
  }

  componentDidUpdate() {
    if (this.state.updData) {
      this.updateStateWithStoreProps();
      this.get_listData();
      this.setState({ updData: false });
    }
  }
  
  componentWillUnmount() {
    
  }
  
  get_listData = () => {
    this.listVm = window.cc.enabledList[this.props.store.filtersState.marca];
    var url = this.listVm ? "epc/get_list_part/" : "epc/get_epc_part/"
    var data = { zprod: this.props.store.filtersState.marca, carti: this.props.store.filtersState.applicazione, cswln: this.listVm };
    common.apiCall(env.BACKEND + url, "GET", data, true, false, 'json', env.RECAPTCHA_VERIFY).then((result) => {
      if (result.error === false) {
        this.setState({ itemInfo: result[0] });
        $('#modalItem').modal('show');
      } else {
        return false;
      }
    });
  }
  
  addToCart = (input = null) => {
    var articoloSosti = null;
    var qta = $(".numArticoloCarello").val();

    //controllo input != event
    if (typeof input === 'object' && !('target' in input)) {
      articoloSosti = input;
      this.closeReplacement();
    }

    if (!qta || !qta.match(/^[0-9]+$/)) {
      $("#addArticoloError").html(common.getTrad("Non sono ammessi valori non numerici"));
      $("#addArticoloError").show();
      return false;
    }
    if (qta > 9999) {
      $("#addArticoloError").html(common.getTrad("Non sono ammessi valori maggiori di 9999"));
      $("#addArticoloError").show();
      return false;
    }
    if (qta < 1) {
      $("#addArticoloError").html(common.getTrad("Non sono ammessi valori inferiori a 1"));
      $("#addArticoloError").show();
      return false;
    }

    let wishList = this.state.dataList.wishList;
    if (this.state.itemInfo.TMOVI === 'S' && !articoloSosti) {
      var data = { zprod: this.props.store.filtersState.marca, carti: this.props.store.filtersState.applicazione, cswln: this.listVm };
      common.apiCall(env.BACKEND + "epc/get_replacements/", "GET", data, true, false, 'json', env.RECAPTCHA_VERIFY).then((data) => {
        if (data.error !== true) {
          var arti = common.cloneFromState(this.state.itemInfo);
          arti.ISPADRE = true;
          arti.QPEZZ = qta;
          data.unshift(arti)
          this.setState({
            sosti: data,
            itemInfo: arti,
            showReplacements: true
          });
        }
      })
      return false;
    }
    let found = false;
    for (let k in wishList) {
      const ZFORNValue = wishList[k]["marca"];
      const CARTIValue = wishList[k]["carti"];
      var carti = articoloSosti ? articoloSosti.CARTI : this.state.itemInfo.CARTI;
      if (ZFORNValue === this.props.store.filtersState.marca && CARTIValue === carti) {
        wishList[k].qpezzi = parseInt(wishList[k].qpezzi) + parseInt(qta);
        found = true;
        break;
      }
    }

    if (!found) {
      var articolo = {
        carti: articoloSosti ? articoloSosti.CARTI : this.state.itemInfo.CARTI,
        cartiSost: articoloSosti ? this.state.itemInfo.CARTI : null,
        darti: articoloSosti ? articoloSosti.DARTI : this.state.itemInfo.DARTI,
        dart2: this.state.itemInfo.DART2,
        marca: this.state.filtersState.marca,
        qpezzi: qta,
        modello: this.state.filtersState.modello,
        tavola: this.state.filtersState.tavola,
        cvalu: this.state.itemInfo.CVALU,
        price: articoloSosti ? articoloSosti.PRICE : this.state.itemInfo.PRICE,
      };
      wishList.push(articolo);
    }
    common.set_localStorage("wishList", JSON.stringify(wishList));
    this.props.changeDatalist("wishList", wishList);
    this.closeButtonRef.current.click();
    $('#btn_resetta').click();
    $('#applicazioni_search').val(this.props.arti);
    $('#applicazioni_search').blur();
    this.setState({ showTooltipCarti: true });
  }

  closeTooltipCart = () => {
    this.setState({
      showTooltipCarti: false
    });
  }

  closeReplacement = () => {
    this.setState({
      showReplacements: false
    });
  }
  
  render() {
    if (this.state.showTooltipCarti)
      return (<TooltipCart handleClose={this.closeTooltipCart} articolo={this.state.itemInfo} />)
    
    if (this.state.itemInfo) {
      let localeLang = common.getLanguageLocale();
      let prezzo = this.state.itemInfo.PRICE;
      let valuta = this.state.itemInfo.CVALU;
      let non_ordinabile = (this.state.itemInfo.FAGGI == "C" && this.state.itemInfo.TMOVI != "S")
      
      let marca = ""
      for (let i = 0; i < this.marcheVm.length; i++) {
        if (this.marcheVm[i][0] === this.props.store.filtersState.marca) {
          marca = this.marcheVm[i][1];
          break;
        }
      }

      const itemSerched = (
        <div className='row'>
          <div className='col-6'>
            <div className='mb-3'>
              <h5 className="withSubtitle">
                {this.state.itemInfo.DARTI}
                <small className='text-muted'>{this.props.arti}</small>
              </h5>
              {this.listVm && <strong>{prezzo.toLocaleString(localeLang, { style: 'currency', currency: valuta })}</strong>}
            </div>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">{common.getTrad("Quantità")}</span>
              </div>
              <input className="form-control numArticoloCarello" type="number" min="1" max="9999" defaultValue="1" />
            </div>
            <div className="mt-2 alert alert-warning" id="addArticoloError" role="alert" style={{display: "none"}}></div>
            <div className='text-right' style={{ marginTop: "1em" }}>
              {(!non_ordinabile) ? (
                <a className='btn bottone_default' onClick={this.addToCart}>
                  {common.getTrad("Aggiungi al carrello") + " "}
                  <i className='fas fa-shopping-cart'></i>
                </a>
              ) : (
                <a className='btn bottone_default' style={{cursor: 'default', pointerEvents: 'none'}}>
                  {common.getTrad("Non ordinabile")}
                </a>
              )}
            </div>
          </div>
          <div className='col-6'>
            <h5 className="mb-4">{common.getTrad("Scopri dove viene utilizzato") + ":"}</h5>
            <FilterModels isModal={true} />
            <FilterTavole isModal={true} />
          </div>
        </div>
      )

      return createPortal(
        <div className="modal fade" id="modalItem" tabIndex="-1" data-backdrop="static" data-keyboard="true" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="modalLabel">{marca + " - " + this.props.arti}</h5>
                <button type="button" className="close" id="closeModal" data-dismiss="modal" aria-label="Close" ref={this.closeButtonRef}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {itemSerched}
              </div>
            </div>
          </div>
          { this.state.showReplacements && <CartiReplacements handleEditWishlistClick={this.addToCart} data={this.state.sosti} articolo={this.state.itemInfo} handleCloseReplacement={this.closeReplacement} /> }
        </div>,
        document.body
      );
    }
    else
      return false;
  }
}

const mapStateToProps = state => {
  const store = modalItemSelector(state);
  return { store };
}
export default connect(mapStateToProps, { changeDatalist, setNewUrlState })(ModalItem);